import * as types from './types';

const Desc = () => (
  <span>Crea e modifica i dati anagrafici relativi alla/e <br/> tua/e società.</span>
);

const initialState = {
  listData: {
    id: 'firms',
    title: 'Anagrafica società:',
    description: <Desc />,
    href: '/profile/firm/:id',
    createLink: '/profile/firm/create',
    inProcess: true,
    items: [],
  },
  itemLoading: false,
  currentItem: {},
  deleteInProcess: false,
  errors: null,
  listFetched: false,
  createOrUpdateInProcess: false,
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.COMPANIES_GET_REQUEST:
      return {
        ...state,
        listData: {
          ...state.listData,
          inProcess: true,
        },
      };
    case types.COMPANIES_GET_SUCCESS:
      return {
        ...state,
        listFetched: true,
        listData: {
          ...state.listData,
          items: action.payload,
        },
      };
    case types.COMPANIES_CREATE_OR_UPDATE_REQUEST:
      return {
        ...state,
        createOrUpdateInProcess: true,
      };
    case types.RESET_COMPANIES_ERRORS:
      return {
        ...state,
        errors: null,
      };
    case types.COMPANIES_GET_BY_ID_REQUEST:
    case types.COMPANIES_GET_BY_ID_FAILURE:
      return {
        ...state,
        itemLoading: true,
      };
    case types.COMPANIES_GET_BY_ID_SUCCESS:
      return {
        ...state,
        itemLoading: true,
        currentItem: action.payload,
      };
    case types.COMPANIES_CREATE_OR_UPDATE_FAILURE:
      return {
        ...state,
        errors: action.payload,
        createOrUpdateInProcess: false,
      };
    case types.COMPANIES_CREATE_OR_UPDATE_SUCCESS:
      return {
        ...state,
        createOrUpdateInProcess: false,
      };
    case types.COMPANIES_DELETE_REQUEST:
      return {
        ...state,
        deleteInProcess: true,
      };
    case types.COMPANIES_DELETE_FAILURE:
    case types.COMPANIES_DELETE_SUCCESS:
      return {
        ...state,
        deleteInProcess: false,
      };
    default:
      return state;
  }
};

export default companyReducer;
